import MainHeader from "../../layouts/MainHeader";
import TransitionBackground from '../../assets/images/wallpaper/transtion.jpg';
import transitionPageData from "../../data/english/transtion-page-data";
import Separator from "../../components/Separator";
import PrimaryLabel from "../../components/Labels/PrimaryLabel";
import Footer from "../../layouts/Footer";
import TableBorderLeft from "../../components/Table/TableBorderLeft";
import TitleGrayBg from "../../components/Text/TitleGrayBg";
import SecondaryCard from "../../components/cards/SecondaryCard";
import FlexViewTwo from "../../components/FlexView/FlexViewTwo/FlexViewTwo";
import ColTwo from "../../components/FlexView/ColTwo";
import HighlighCard from "../../components/cards/HighlightCard";

const TransitionPage = () => {
    return (
            <main id="main" className="page">
                <div className="sticky-view-two">
                    <div className="sticky-container">
                        <MainHeader title={""} image={{
                            src : TransitionBackground,
                            alt : "Beutefull view"
                        }} />
                    </div>
                    <div className="sticky-container-two" id="mainContent">
                        <div className="wrapper-small">
                            <h1 className="title-center">{transitionPageData.title}</h1>
                            <article className="text-paragraph">{transitionPageData.praghraphOne}</article>
                            <div className="space-50"></div>
                            <div className="space-50"></div>
                            <div className="space-50"></div>
                            <TitleGrayBg 
                                text={transitionPageData.sectionOne.title}
                                redColor
                                textSize="meduim"
                            />
                            <div className="space-50"></div>
                            <div className="space-50"></div>
                            <TableBorderLeft 
                                items={transitionPageData.sectionOne.gridOne.map((item, index) => {
                                    return {
                                        number : item.number,
                                        subtitle : item.subtitle,
                                        icon : {
                                            src : require(`../../assets/icons/transition-icons/${item.icon.name}`),
                                            alt : item.icon.alt,
                                        },
                                        subtitleTwo : item.subtitleTwo,
                                        numberTwo : item.nubmerTwo,
                                    }
                                })}
                            />
                            
                            <Separator />
                            <TableBorderLeft 
                                items={transitionPageData.sectionOne.gridTwo.map((item, index) => {
                                    return {
                                        number : item.number,
                                        subtitle : item.subtitle,
                                        icon : {
                                            src : require(`../../assets/icons/transition-icons/${item.icon.name}`),
                                            alt : item.icon.alt,
                                        },
                                        subtitleTwo : item.subtitleTwo,
                                        numberTwo : item.nubmerTwo,
                                    }
                                })}
                            />
                            <Separator />
                        </div>
                        
                            <SecondaryCard 
                                icon={{
                                    name : require(`../../assets/icons/transition-icons/${transitionPageData.sectionOne.cardOne.icon.name}`),
                                    alt : transitionPageData.sectionOne.cardOne.icon.alt,
                                }}
                                number={transitionPageData.sectionOne.cardOne.title}
                                subtitle={transitionPageData.sectionOne.cardOne.subtitle}
                            />
                            <Separator />
                        <div className="wrapper-small">
                            {
                            transitionPageData.sectionThree.map((item, index) => (
                                <>
                                <PrimaryLabel 
                                    key={index}
                                    title={typeof item.colOne === "string" ? item.colOne : item.colOne.number}
                                    subtitle={item.colTwo}
                                    type={"one"}
                                    revirsed={true}
                                />
                                <Separator />
                                </>
                            ))
                            }
                            <p className="text-paragraph text-center">This programme will be rolled out across all SAB's branches and buildings in 2023.</p>
                            <div className="space-50"></div>
                            <div className="space-50"></div>
                            <div className="space-50"></div>
                            <TitleGrayBg 
                                text={transitionPageData.sectionFour.title}
                                redColor
                                textSize="meduim"
                            />
                            <p className="text-paragraph">{transitionPageData.sectionFour.subtitle}</p>
                            <FlexViewTwo>
                                {transitionPageData.sectionFour.cards.map((item, index) => (
                                <ColTwo
                                    key={index}
                                >
                                    <HighlighCard
                                        number={item.number || undefined}
                                        title={item.title}
                                        subtitle={item.subtitle}
                                    />
                                </ColTwo>
                                ))}
                            </FlexViewTwo>
                            <p className="text-paragraph">{transitionPageData.sectionFour.paragraphOne}</p>
                            <FlexViewTwo>
                                {transitionPageData.sectionFour.cardsTwo.map((item, index) => (
                                <ColTwo
                                    key={index}
                                >
                                    <HighlighCard
                                        number={item.number || undefined}
                                        title={item.title}
                                        subtitle={item.subtitle}
                                    />
                                </ColTwo>
                                ))}
                            </FlexViewTwo>
                            <p className="text-paragraph">{transitionPageData.sectionFour.paragraphTwo}</p>
                            <p className="text-paragraph">{transitionPageData.sectionFour.paragraphThree}</p>
                            <div className="space-50"></div>
                            <div className="space-50"></div>
                            <div className="space-50"></div>
                        </div>
                        <Footer withBlogs={false} />
                        
                    </div>
                </div>
            </main>
    )
}

export default TransitionPage;